// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-p_ga","advertDetailServiceList__header":"c-p_gb","advertDetailServiceList__list":"c-p_gc"};